module.exports = __webpack_public_path__ + "static/1-626a939a3c3ab7a14f2ab60437caca5b.jpg";